export default __webpack_public_path__ + "static/media/woodblock.6af086c9.mp3";